/**
 * Static palette — fixed, non-themed colours used directly in screen styles.
 *
 * Use this ONLY for things that are intentionally constant regardless of theme
 * or accent: elevation shadows, modal scrims, and the brand "chrome" navy/bronze
 * banners & blooms (the same fixed-navy decision as the sidebar — see
 * `accentChrome` in ./accents if you ever want these to follow the accent).
 *
 * For functional UI colour (icons, text, active states) use Tamagui theme
 * tokens instead — `$primary` / `$primaryActive` / `$muted` / `$tertiary` /
 * `$color` — so they follow light/dark + the selected accent. Semantic status
 * colours live in ./tones (`tone()` / `$tone_*`).
 */
import { navy, bronze } from './brand'

export const palette = {
  // soft navy elevation shadow (cards, dropdowns, popovers, raised pills)
  shadow: '#142864',

  // overlays behind modals / drawers
  scrim: 'rgba(0,0,0,0.5)',
  scrimSoft: 'rgba(0,0,0,0.4)',

  // brand chrome — fixed navy + bronze banners/blooms (NOT accent-driven)
  coverNavy: navy.sidebarTop, // #16265C — profile cover / learning hero / org card
  navy: navy.navy9, // #1D4289 — decorative navy bloom / ring / calendar "today"
  navySoft: 'rgba(29,66,137,0.12)',
  bronzeBrushed: '#C2974E', // brushed-bronze brand edge
  bronzeLight: bronze.bronzeLight, // #D8BE88
} as const

export type Palette = typeof palette
